import { useState } from "react";
export default function AnimatedInput({
  isPress,
  type,
  name,
  required,
  children,
  onInputChange,
  area,
  value
}) {
  const [active, setActive] = useState(false);

  function handleActivation(e) {
    onInputChange(e);
    setActive(!!e.target.value);
  }

  return (
    <div className="relative border-b rounded mb-2 bg-gray-600 text-gray-50 border-black border-opacity-25 truncate ">
      <input
        value={value}
        className={[
          area ? "pb-20" : "",
          `outline-none w-full rounded ${
            isPress ? "bg-gray-5" : "bg-transparent"
          }  text-sm text-gray-80 transition-all duration-200 ease-in-out p-3`,
          active ? "pt-6" : ""
        ].join(" ")}
        id={name}
        name={name}
        type={type}
        onChange={handleActivation}
      />
      <label
        className={[
          "absolute top-0 left-0 flex items-center text-gray-50 text-opacity-50 p-2 transition-all duration-200 ease-in-out",
          active ? "text-xs" : "text-sm"
        ].join(" ")}
        htmlFor={name}
      >
        {children}
        {required && (
          <span className="flex items-center justify-center text-primary">
            &nbsp;*
          </span>
        )}
      </label>
    </div>
  );
}
